/* ==========================================================================
   GEEKFOLK — dopieszczenie karty produktu
   1. FAQ: płynne rozwijanie zamiast skoku
   2. Galeria: przenikanie zamiast błysku przy zmianie zdjęcia
   3. „Klienci kupili także": dogranie prawdziwych rekomendacji Shopify
   Wszystko degraduje się łagodnie — bez JS strona działa jak dotąd.
   ========================================================================== */
(function () {
  'use strict';

  var mniejRuchu = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- 1. FAQ */
  function faq() {
    var pytania = document.querySelectorAll('.gf-desc__faq details');
    if (!pytania.length) return;

    Array.prototype.forEach.call(pytania, function (d) {
      var sum = d.querySelector('summary');
      var body = sum && sum.nextElementSibling;
      if (!sum || !body) return;

      body.classList.add('gf-faq__body');

      sum.addEventListener('click', function (e) {
        if (mniejRuchu) return;
        e.preventDefault();
        if (d.dataset.anim === '1') return;
        d.dataset.anim = '1';

        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          body.addEventListener('transitionend', function koniec() {
            body.removeEventListener('transitionend', koniec);
            d.open = false;
            body.style.height = '';
            d.dataset.anim = '';
          });
        } else {
          d.open = true;
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = body.scrollHeight + 'px'; });
          body.addEventListener('transitionend', function koniec() {
            body.removeEventListener('transitionend', koniec);
            body.style.height = 'auto';
            d.dataset.anim = '';
          });
        }
      });
    });
  }

  /* ------------------------------------------------------------ 2. Galeria */
  /* Poprzednie podejście (klasa CSS + transition) nie działało: motyw podmienia
     src w tej samej klatce, w której dodawaliśmy klasę, więc przeglądarka nie
     zdążyła narysować stanu wyjściowego i nie było czego animować.
     Teraz obserwujemy atrybut src i po każdej podmianie odpalamy animację
     przez Web Animations API — to nie zależy od timingu paintu. */
  function galeria() {
    var glowne = document.querySelector('[data-gallery-main]');
    if (!glowne || mniejRuchu || !glowne.animate || !window.MutationObserver) return;

    function przenikaj() {
      glowne.animate(
        [
          { opacity: 0, transform: 'scale(0.975)' },
          { opacity: 1, transform: 'scale(1)' }
        ],
        { duration: 300, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'none' }
      );
    }

    new MutationObserver(function (zmiany) {
      for (var i = 0; i < zmiany.length; i++) {
        if (zmiany[i].attributeName === 'src') { przenikaj(); return; }
      }
    }).observe(glowne, { attributes: true, attributeFilter: ['src'] });
  }

  /* ------------------------------------------------------- 3. Rekomendacje */
  function rekomendacje() {
    var sekcja = document.querySelector('[data-gf-reco]');
    if (!sekcja) return;
    var url = sekcja.getAttribute('data-gf-reco');
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var zrodlo = doc.querySelector('[data-carousel-track]');
        var cel = sekcja.querySelector('[data-carousel-track]');
        if (!zrodlo || !cel) return;
        if (zrodlo.querySelector('.card:not(.card--demo)')) {
          cel.innerHTML = zrodlo.innerHTML;
          sekcja.removeAttribute('data-gf-reco');
        }
      })
      .catch(function () { /* zostaje fallback z kolekcji */ });
  }

  function start() { faq(); galeria(); rekomendacje(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
